import React from 'react'
import { Box, Button, Flex, Image, Grid } from '@chatterbug/aaron'
import PropTypes from 'prop-types'
import { t } from 'src/lib/i18n-react'

import { getLanguageName } from 'lib/util'

import illustration from './assets/illustration.svg'

const C1Prompt = ({ l2Code, onClick }) => {
  return (
    <Grid
      gridGap="3x"
      justifyItems="center"
      backgroundColor="white100"
      borderRadius="1x"
      borderColor="gray88"
      borderStyle="dashed"
      borderWidth="2px"
      p="4x"
      textAlign="center"
    >
      <Image src={illustration} alt="" />
      <Box as="p" variant="text.h4">
        {t('Customized C1 Course')}
      </Box>
      <Box as="p" variant="text.paragraph">
        {t(
          'When you reach Advanced levels of %{languageName}, you can build your own custom course from a variety of topics.',
          { languageName: getLanguageName(l2Code) }
        )}
      </Box>
      <Box as="p" variant="text.subtitle" fontSize="sm">
        {t(
          'Have you completed B2 or equivalent and are ready to start learning in C-level?'
        )}
      </Box>
      <Flex width={{ _: '100%', tablet: 'auto' }} justifyContent="center">
        <Button
          type="primaryAdvanced"
          fill="outline"
          onClick={onClick}
          data-testid="join-button"
          width="100%"
        >
          {t('Join c-level now')}
        </Button>
      </Flex>
    </Grid>
  )
}

C1Prompt.propTypes = {
  l2Code: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default C1Prompt
